import React from 'react';

const DetailCard = ({
  Icon,
  title,
  description,
}: {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
}) => {
  return (
    <div className="flex w-full flex-col items-center justify-center rounded-lg border border-color-border-input-lightmode p-ds-md text-center dark:border-color-border-input-darkmode">
      <Icon className="h-5 w-5 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
      <p className="md:typography-product-element-label xs:typography-product-caption mt-ds-xs w-full text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {title}
      </p>
      <p className="md:typography-product-element-label xs:typography-product-element-label mt-ds-md text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        {description}
      </p>
    </div>
  );
};

export default DetailCard;
